import { Component, Input } from '@angular/core';

import { AIItem } from '../../models/call-history.model';

@Component({
  selector: 'app-ai-list',
  templateUrl: './ai-list.component.html',
  styleUrls: ['./ai-list.component.scss'],
})
export class AiListComponent {
  @Input() aiData: AIItem;

  public copy(text: string, tooltip: any): void {
    navigator.clipboard.writeText(text).then(() => {
      tooltip.open();
      setTimeout(() => tooltip.close(), 2000);
    });
  }
}
